import { ROUTES } from "../data/content";
import { Reveal, SectionHead } from "./Reveal";
import { useI18n } from "../i18n";
import { ArrowRight } from "lucide-react";

export default function PortalRouting() {
  const { tr } = useI18n();
  return (
    <section id="routing" data-testid="portal-routing-section" className="py-24 lg:py-32" style={{ background: "linear-gradient(135deg, #EAF4FD 0%, #F6FAFF 60%, #E8F7F0 100%)" }}>
      <SectionHead
        index="§ 04"
        eyebrow="Country Portal Engine"
        title="One engine underneath. A branded portal for every nation."
        sub="Premium countries get independent domains. Everyone else is served by the global engine — and when a domain is acquired, the location IDs, content and relationships never change."
      />

      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="mt-14 border border-[#BFD4F2] rounded-3xl overflow-hidden bg-white">
          {ROUTES.map((r, i) => (
            <Reveal key={r.country} delay={i * 0.06} y={14}>
              <div
                data-testid="portal-routing-result"
                className={`grid grid-cols-12 items-center gap-3 px-5 lg:px-8 py-5 group hover:bg-[#EAF2FD] transition-colors duration-300 ${i < ROUTES.length - 1 ? "border-b border-[#E5EDF7]" : ""}`}
              >
                <div className="col-span-6 md:col-span-3 flex items-center gap-3">
                  <span className="text-xl">{r.flag}</span>
                  <span className="font-atlas text-xl text-[#0F2557]">{r.country}</span>
                </div>
                <div className="hidden md:block md:col-span-4 font-mono-wp text-xs text-[#64748B] truncate">{r.route}</div>
                <div className="hidden md:flex md:col-span-1 justify-center">
                  <ArrowRight size={14} className="text-[#2563EB] group-hover:translate-x-1 transition-transform duration-300" />
                </div>
                <div className="col-span-4 md:col-span-2 font-mono-wp text-xs font-semibold text-[#16A34A]">{r.domain}</div>
                <div className="col-span-2 md:col-span-2 font-mono-wp text-[0.6rem] uppercase tracking-[0.15em] text-[#94A3B8] text-right">{tr(r.status)}</div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <div className="mt-10 font-mono-wp text-xs text-[#64748B] flex flex-wrap gap-x-6 gap-y-2">
            <span>indias.com/kerala/kottayam/pala</span>
            <span className="text-[#EA580C]">·</span>
            <span>usapulse.net/oregon/multnomah-county/portland</span>
            <span className="text-[#EA580C]">·</span>
            <span>worldpulse.pro/country/ghana</span>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
